'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import { ServerErrorPage } from '@/components/shared/error'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Capture error with additional context
    Sentry.captureException(error, {
      tags: {
        errorBoundary: 'global-error',
        errorType: '500',
      },
      extra: {
        errorDigest: error.digest,
        errorMessage: error.message,
        errorStack: error.stack,
      },
    })
  }, [error])

  return (
    <html lang="en">
      <body style={{ margin: 0, padding: 0 }}>
        <ServerErrorPage />
      </body>
    </html>
  )
}
